<template>
  <v-menu
    v-model="filterMenu"
    bottom
    left
    :close-on-content-click="false"
    attach=".school-switcher-container"
    :absolute="true"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        dark
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        class="pr-2"
      >
        <v-list-item-title class="d-flex justify-space-between success--text">
          <span
            style="font-size:14px;"
            class="pr-5"
          >
            {{ $t('mySchool.overlay.switchSchool') }}
          </span>
          <v-icon
            class="pr-2"
            @click="filterMenu = false"
            size="18"
            color="success"
          >
            close
          </v-icon>
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-for="(school, i) in mySchools"
        :key="i"
        class="school-card mx-4 mb-2 py-3"
        :class="$route.params.id === school.schoolId ? 'active' : null"
        @click="$router.push(`/school/${school.schoolId}`)"
      >
        <v-list-item-title style="font-size:14px; white-space:normal">
          <div class="d-flex">
            <v-icon class="mr-3">
              {{ $route.params.id === school.schoolId ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
            </v-icon>
            <span class="pr-2">
              <div
                class="school-logo"
                :style="`border-color: ${school.details.colour}`"
              >
                <v-img
                  :src="school.details.logo"
                  height="18px"
                  width="18px"
                />
              </div>
            </span>
            <span
              class="d-flex align-center"
            >
              {{ school.details.name }}
            </span>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { AppIcon } from '@nswdoe/doe-ui-core';
import { mapGetters } from 'vuex';
const AppBarFilters = {
    name: "SchoolSwitcher",
    components: {
        AppIcon
    },
    computed: {
      ...mapGetters(['mySchools'])
    },
    methods: {
      schoolName(id) {
        if (id != 'global') {
          return this.mySchools.find(school => school.schoolId == id)?.details.name
        }

        return 'NSW Department of Education'
      },
      schoolLogo(id) {
        if (id != 'global') {
          return this.mySchools.find(school => school.schoolId == id)?.details.logo
        }

        return 'my-nsw-gov';
      },
      getSchoolColour(schoolId) {
        if(schoolId != 'global') {
          return this.mySchools.find(schoolInfo => schoolInfo.schoolId == schoolId)?.details.colour;
        }
        return '#264189';
      }
    },
    data(){
      return {
        filterMenu: false,
      }
    },
    watch:{
        title(){
            this.filter = this.mySchools.map((school,i) => {
              let schoolId = school.schoolId;
              return {
                        "id":schoolId,
                        "value": this.appFilters[i] ? this.appFilters[i].value : false
                     }
            }
           )
            console.log('app Filter changes');
        }
    }
}
export default AppBarFilters;
</script>
<style lang="scss" scoped>
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
  background-color: white;
  margin: 6px 0;
}
.school-card {
  border: 1px solid #407EC9;
  border-radius: 4px;
  &.active {
    background-color: #CBEDFD;
  }
}
</style>
